export default "__VITE_ASSET__YTJQS9Ac__"